import { renderizarValor } from "../../functions/dataFunctions";

/* EL ENCABEZADO QUE ORDENA, para la tabla de los padrones.
 *
 * Es el mismo de «Choferes», «Nómina» y «Documentación» —el mismo `button`, las
 * mismas clases `.th-orden` / `.th-flecha`, la misma flecha— y el ciclo es el
 * de Documentación: ascendente → descendente → sin orden. Sin el tercer paso,
 * un toque de más deja la lista en un orden que no se puede deshacer sin
 * recargar la pantalla.
 *
 * Aquellas tres pantallas tienen cada una su copia adentro; ésta vive en
 * `tablas/` porque la tabla de los padrones es una sola para los ocho
 * listados. */
const ThOrden = ({ columna, orden, alTocar, children }) => {
  const activo = orden.columna === columna;
  const flecha = !activo ? "" : orden.desc ? " ↓" : " ↑";
  return (
    <th aria-sort={!activo ? undefined : orden.desc ? "descending" : "ascending"}>
      <button
        type="button"
        className={"th-orden" + (activo ? " activo" : "")}
        onClick={() => alTocar(columna)}
      >
        {children}
        <span className="th-flecha">{flecha}</span>
      </button>
    </th>
  );
};

export default ThOrden;

export const SIN_ORDEN = { columna: null, desc: false };

/* Ascendente → descendente → como venía. */
export const siguienteOrden = (o, columna) =>
  o.columna !== columna
    ? { columna, desc: false }
    : o.desc
      ? SIN_ORDEN
      : { columna, desc: true };

const FECHA_AR = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(.*)$/;

/* Con qué se compara una celda.
 *
 * SE ORDENA POR LO QUE SE VE —el mismo `renderizarValor` que dibuja la celda y
 * que usa el filtro—, con una sola excepción: las fechas. «05/10/2026» y
 * «28/09/2026» comparadas como texto quedan al revés, así que una fecha se
 * lleva a un número (si viene como fecha) o a año-mes-día (si viene escrita). */
const claveDe = (fila, columna) => {
  const crudo = fila?.[columna];
  if (crudo instanceof Date) return crudo.getTime();
  const seg = crudo?.seconds ?? crudo?._seconds;
  if (typeof seg === "number") return seg * 1000;
  if (typeof crudo === "number") return crudo;

  const texto = String(renderizarValor(crudo, columna) ?? "").trim();
  if (texto === "" || texto === "-") return "";
  const f = texto.match(FECHA_AR);
  return f
    ? `${f[3]}-${f[2].padStart(2, "0")}-${f[1].padStart(2, "0")}${f[4]}`
    : texto;
};

/* `numeric` es lo que pone el interno 2 antes que el 10, y `base` lo que hace
 * que «Álvarez» caiga con la A y no después de la Z. */
const comparar = (a, b) =>
  typeof a === "number" && typeof b === "number"
    ? a - b
    : String(a).localeCompare(String(b), "es", {
        numeric: true,
        sensitivity: "base",
      });

/* Devuelve una lista NUEVA: la que entra es la filtrada, y otros la siguen
 * usando tal cual. Sin columna devuelve la misma, sin tocar.
 *
 * LO QUE NO TIENE DATO VA SIEMPRE ÚLTIMO, en las dos direcciones (igual que en
 * Documentación): ordenando al revés, seiscientos huecos arriba taparían
 * justo lo que se fue a buscar. */
export const ordenarFilas = (filas, { columna, desc } = SIN_ORDEN) => {
  if (!columna) return filas;
  const signo = desc ? -1 : 1;
  return filas
    .map((fila, i) => ({ fila, i, k: claveDe(fila, columna) }))
    .sort((a, b) => {
      const va = a.k === "";
      const vb = b.k === "";
      if (va !== vb) return va ? 1 : -1;
      // A igualdad, el orden en que venían: que un empate no baraje la lista.
      return (va ? 0 : signo * comparar(a.k, b.k)) || a.i - b.i;
    })
    .map((x) => x.fila);
};
